export const CREATE_POST_MUTATION = `
  mutation CreatePost($input: CreatePostInput!) {
    createPost(input: $input) {
      id
      mainCategory
      subCategory
      postTitle
      postDescription
      postKeywords
      postRadius
      postSuburb
      title
      content
      author
      userId
      createdAt
      updatedAt
      isHighlighted
      status
      likes
      views
    }
  }
`;

export const CreatePostMutation = async (graphqlService, variables) => {
    try {
        const response = await graphqlService.mutateData(CREATE_POST_MUTATION, variables);
        return response;
    } catch (error) {
        console.error("Mutation Error:", error);
        throw error;
    }
};

export const UPDATE_POST_MUTATION = `
  mutation UpdatePost($input: PostInput!) {
    updatePost(input: $input) {
      id
      mainCategory
      subCategory
      postTitle
      postDescription
      postKeywords
      postRadius
      postSuburb
      title
      content
      author
      userId
      createdAt
      updatedAt
      isHighlighted
      status
      likes
      views
    }
  }
`;

export const UpdatePostMutation = async (graphqlService, variables) => {
    try {
        const response = await graphqlService.mutateData(UPDATE_POST_MUTATION, variables);
        return response;
    } catch (error) {
        console.error("Mutation Error:", error);
        throw error;
    }
};

export const UPDATE_POST_STATUS_MUTATION = `
  mutation UpdatePostStatus($id: Float!, $status: String!) {
    updatePostStatus(id: $id, status: $status) {
      id
      mainCategory
      subCategory
      postTitle
      postDescription
      postKeywords
      postRadius
      postSuburb
      title
      content
      author
      userId
      status
      likes
      views
      isHighlighted
      createdAt
      updatedAt
    }
  }
`;

export const UpdatePostStatusMutation = async (graphqlService, variables) => {
    try {
        const response = await graphqlService.mutateData(UPDATE_POST_STATUS_MUTATION, variables);
        return response;
    } catch (error) {
        console.error("Mutation Error:", error);
        throw error;
    }
};

export const POSTS_BY_USER_ID_AND_STATUS_QUERY = `
  query GetPostsByStatus($userId: Float!, $status: String!) {
    getPostsByStatus(userId: $userId, status: $status) {
      id
      mainCategory
      subCategory
      postTitle
      postDescription
      postKeywords
      postRadius
      postSuburb
      title
      content
      author
      userId
      status
      likes
      views
      isHighlighted
      createdAt
      updatedAt
    }
  }
`;

export const GetPostsByUserIdAndStatus = async (graphqlService, variables) => {
    try {
        const response = await graphqlService.fetchData(POSTS_BY_USER_ID_AND_STATUS_QUERY, variables, { fetchPolicy: 'network-only' });
        return response;
    } catch (error) {
        console.error("Query Error:", error);
        throw error;
    }
};

export const POST_BY_ID_QUERY = `
  query GetPostById($id: Float!) {
    getPostById(id: $id) {
      id
      mainCategory
      subCategory
      postTitle
      postDescription
      postKeywords
      postRadius
      postSuburb
      title
      content
      author
      userId
      status
      likes
      views
      isHighlighted
      createdAt
      updatedAt
      user {
        id
        profilePicture
        firstName
        lastName
        businessName
        location
        startDate
        serviceCategory {
          id
          name
        }
        userPlan {
          plan {
            name
          }
        }
      }
      
    }
  }
`;

export const GetPostById = async (graphqlService, variables) => {
    try {
        const response = await graphqlService.fetchData(POST_BY_ID_QUERY, variables);
        return response;
    } catch (error) {
        console.error("Query Error:", error);
        throw error;
    }
};

export const GET_POSTS_BY_CATEGORY_QUERY = `
  query GetPostsByCategory($filters: PostFilterInput!) {
  getPostsByCategory(filters: $filters) {
    posts {
      id
      mainCategory
      postTitle
      postDescription
      content
      likes
      views
      isHighlighted
      createdAt
      user {
        id
        profilePicture
        firstName
        lastName
        businessName
        location
        startDate
          serviceCategory {
            id
            name
          }
          userPlan {
            plan {
              name
            }
          }
        }
      postImages {
        imageUrl
      }
    }
    totalCount
  }
}
`;

export const GetPostsByCategory = async (graphqlService, variables) => {
    try {
        const response = await graphqlService.fetchData(GET_POSTS_BY_CATEGORY_QUERY, variables);
        return response;
    } catch (error) {
        console.error("Query Error:", error);
        throw error;
    }
};

export const GET_RECENT_POSTS_QUERY = `
  query GetRecentPosts($filters: PostFilterInput) {
    getRecentPosts(filters: $filters) {
      posts {
        id
        mainCategory
        postTitle
        postDescription
        content
        createdAt
        user {
        id
        profilePicture
        firstName
        lastName
        businessName
        location
        startDate
          serviceCategory {
            id
            name
          }
          userPlan {
            plan {
              name
            }
          }
        }
        postImages {
          imageUrl
        }
      }
      totalCount
    }
  }
`;

export const GetRecentPosts = async (graphqlService) => {
    try {
        const response = await graphqlService.fetchData(GET_RECENT_POSTS_QUERY);
        return response;
    } catch (error) {
        console.error("Query Error:", error);
        throw error;
    }
};

export const INCREMENT_POST_VIEWS_MUTATION = `
  mutation incrementPostViews($id: Float!) {
    incrementPostViews(id: $id) {
      id
      views
    }
  }
`;

export const IncrementPostViews = async (graphqlService, variables) => {
    try {
        const response = await graphqlService.mutateData(INCREMENT_POST_VIEWS_MUTATION, variables);
        return response;
    } catch (error) {
        console.error("Mutation Error:", error);
        throw error;
    }
}; 